import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarClock, Smartphone } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Kicker } from "@/components/landing/Section";

export const LaunchStrip = ({ testId = "launch-strip" }) => {
  const { t } = useLang();
  const s = t.pages.signup;
  return (
    <div data-testid={testId} className="rounded-[1.75rem] border-2 border-dashed border-amber/60 bg-amber/10 p-6 md:p-8 flex flex-col lg:flex-row lg:items-center gap-6 justify-between">
      <div className="flex gap-4">
        <CalendarClock className="w-8 h-8 text-amber-dark shrink-0 mt-1" />
        <div>
          <div className="text-xs font-extrabold uppercase tracking-[0.16em] text-amber-dark">{s.launchKicker}</div>
          <p className="mt-1 font-display text-xl md:text-2xl font-semibold text-ink">{s.launchTitle}</p>
          <p className="mt-2 text-ink-muted leading-relaxed max-w-3xl">{s.launchBody}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-3 shrink-0">
        <Link to="/supporter#signup" data-testid={`${testId}-signup`} className="inline-flex items-center gap-2 rounded-full bg-moss hover:bg-moss-dark text-parchment px-6 py-3 font-extrabold transition-colors">
          {s.launchCta} <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/get-app" data-testid={`${testId}-test-app`} className="inline-flex items-center gap-2 rounded-full border-2 border-ink px-5 py-2.5 font-extrabold text-ink hover:bg-ink hover:text-parchment transition-colors">
          <Smartphone className="w-4 h-4" /> {s.testApp}
        </Link>
      </div>
    </div>
  );
};

export const PartnerBand = ({ testId = "partner-band" }) => {
  const { t } = useLang();
  const s = t.pages.signup;
  return (
    <section data-testid={testId} className="relative overflow-hidden rounded-[2rem] bg-ink text-parchment grid lg:grid-cols-2">
      <div className="p-8 sm:p-10 md:p-14">
        <Kicker className="!text-amber">{s.bandKicker}</Kicker>
        <h2 className="mt-5 font-display text-3xl sm:text-4xl font-semibold tracking-tight leading-[1.1]">{s.bandTitle}</h2>
        <p className="mt-5 text-base md:text-lg text-parchment/80 leading-relaxed">{s.bandBody}</p>
        <Link to="/supporter#signup" data-testid={`${testId}-cta`} className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber hover:bg-amber-dark text-parchment px-7 py-3.5 font-extrabold transition-[background-color,transform] duration-200 hover:-translate-y-0.5">
          {s.bandCta} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <img src="/trails/partner.webp" alt="" loading="lazy" className="w-full h-64 lg:h-full object-cover" />
    </section>
  );
};
